module.exports = __webpack_public_path__ + "img/pressure_On.103fafb3.png";